import Dexie, { type Table } from "dexie";

export interface ScanDraft {
  id: string;
  checkpointId: string;
  routeId?: string;
  assignmentId?: string;
  token: string;
  clientTs: string;
  lat?: number;
  lng?: number;
  accuracy?: number;
  notes?: string;
  photoDataUrl?: string;
  createdAt: string;
  retries: number;
  online: boolean;
}

export interface SyncLog {
  id?: number;
  status: "pending" | "success" | "error";
  message?: string;
  createdAt: string;
}

export interface AssignmentCache {
  id: string;
  payload: unknown;
  updatedAt: string;
}

export interface GuardRecord {
  id: string;
  employeeId: string;
  name: string;
  email: string;
  phone: string;
  role: "GUARD" | "SUPERVISOR" | "ADMIN";
  status: "ACTIVE" | "INACTIVE" | "SUSPENDED" | "DEACTIVATED";
  lastActive: string;
  assignedRoutes: string[];
  hireDate: string;
  emergencyContact: string;
  badgeDataUrl: string;
  password?: string;
}

export interface AiQueryRecord {
  id: string;
  question: string;
  answer: string;
  sql: string;
  createdAt: string;
  rowCount: number;
}

class PatrolDexie extends Dexie {
  scanDrafts!: Table<ScanDraft, string>;
  syncLogs!: Table<SyncLog, number>;
  assignments!: Table<AssignmentCache, string>;
  guards!: Table<GuardRecord, string>;
  aiQueries!: Table<AiQueryRecord, string>;

  constructor() {
    super("emory-patrol-db");
    this.version(1).stores({
      scanDrafts: "id, assignmentId, checkpointId, createdAt",
      syncLogs: "++id, createdAt",
      assignments: "id, updatedAt"
    });
    this.version(2).stores({
      scanDrafts: "id, assignmentId, checkpointId, createdAt",
      syncLogs: "++id, createdAt",
      assignments: "id, updatedAt",
      guards: "id, employeeId, role, status"
    });
    this.version(3).stores({
      scanDrafts: "id, assignmentId, checkpointId, createdAt",
      syncLogs: "++id, createdAt",
      assignments: "id, updatedAt",
      guards: "id, employeeId, role, status",
      aiQueries: "id, createdAt"
    });
    this.version(4).stores({
      scanDrafts: "id, assignmentId, checkpointId, createdAt",
      syncLogs: "++id, createdAt",
      assignments: "id, updatedAt",
      guards: "id, employeeId, role, status", // Schema same, but interface updated
      aiQueries: "id, createdAt"
    });
  }
}

export const patrolDb = new PatrolDexie();
